module.exports = __webpack_public_path__ + "static/media/mobile_locationpartners_logos.ccae9b1c.png";